<template>
  <inputFieldVue
    :inputData="inputData"
    @triggermachine="triggermachine($event)"
  />
</template>

<script>
import inputFieldVue from "../components/DropDown.vue";
import axios from "axios";
export default {
  components: {
    inputFieldVue,
  },
  props: ["routed_machineID"],
  data() {
    return {
      lengthOfMachine: null,
      inputData: {
        select: "",
        Items: [],
        icon: "icon-dpimm",
        label: "Select Machines",
        item_text: "machine_name",
        item_value: "id",
      },
    };
  },
  mounted() {
    console.log("routed_machineID in machine select", this.routed_machineID,this.inputData);
    let endPoint = "getMachines?active='Y'";
    if (this.$route.name == "OverallAuditData") {
      endPoint = "getAuditName";
      this.inputData.label = "Select Audit"
    }

    let config = {
      method: "get",
      url: `${this.$config.backend_url}/${endPoint}`,
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };
    axios(config).then((response) => {
      this.inputData.Items = response.data.data || [];
      this.lengthOfMachine = response.data.data.length;
      console.log("checkingthis.lengthOfMachine,this.inputData.Items",this.lengthOfMachine,this.inputData.Items,this.routed_machineID)
      if (this.lengthOfMachine > 1 && this.routed_machineID == null) {
        this.inputData.select = null;
      } else if (this.lengthOfMachine == 1) {
        console.log("checkingthis.lengthOfMachine,this.inputData.Items second time",this.lengthOfMachine,this.inputData.Items,this.routed_machineID)
        this.inputData.select = response.data.data[0].id;
        let event =  {};
        event['selectmachine'] = response.data.data[0].id;
        event['data'] = this.inputData
        this.triggermachine(event);
      } else if (this.routed_machineID != null) {
        this.inputData.select = this.routed_machineID;
      }
    });
  },
  methods: {
    triggermachine(event) {
      console.log("triggered event",event)
      this.$emit("triggermachine", event);
      //this will trigger the event in newfilter and it will make new API call for page reload for new machine
    },
  },
};
</script>
